module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-Light.c7d0b288.woff";